import { TFU, TTFUWidget } from '../../store/TFU';
import { apiService } from '../APIService';
import { ApiAdvancedFilter, PaginatedResponse } from '../../store/GeneralStore';
import { buildAdvancedQueryURL } from '../../utils/helpers';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getTFUs = (filters?: ApiAdvancedFilter) => {
  const mergedFilters: ApiAdvancedFilter = {
    page: 1,
    pageSize: 100,
    ...filters,
    orders: filters?.orders ?? [{ sort: 'dueDate', direction: 'desc' }]
  };

  return apiService.callExternalApi<PaginatedResponse<TFU>>({
    url: buildAdvancedQueryURL(mergedFilters, 'ticket-follow-ups'),
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const getTicketTFUs = (ticketId: string) => {
  const url = `${process.env.REACT_APP_API_SERVER_URL}/ticket-follow-ups/ticket/${ticketId}`;
  return apiService.callExternalApi<TFU[]>({
    url,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const getTFUWidget = () => {
  const url = `${process.env.REACT_APP_API_SERVER_URL}/ticket-follow-ups/widgets/user`;
  return apiService.callExternalApi<TTFUWidget>({
    url,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};

export const postTFU = (data: TFU) => {
  return apiService.callExternalApi<TFU>({
    url: `${API_SERVER_URL}/ticket-follow-ups`,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    data
  });
};

export const putTFU = (data: TFU) => {
  return apiService.callExternalApi<TFU>({
    url: `${API_SERVER_URL}/ticket-follow-ups/${data.id}`,
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    data
  });
};

export const deleteTFU = (id: string) => {
  return apiService.callExternalApi<null>({
    url: `${API_SERVER_URL}/ticket-follow-ups/${id}`,
    method: 'DELETE',
    headers: { 'content-type': 'application/json' }
  });
};
